export default __webpack_public_path__ + "static/media/TownPlanning.73c65963.svg";